import React, { Dispatch, SetStateAction, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageIcon from '@mui/icons-material/Language';
import { Collapse, List, ListItem, TextField } from '@mui/material';
import { SharedItemUI } from './SharedItemUI';
import CopyButtonAdornment from './CopyButtonAdornment';

export const PublicSharing = ({
    isPublic,
    setIsPublic,
    publicUrl,
    translationKey,
}: {
    isPublic: boolean;
    setIsPublic: Dispatch<SetStateAction<boolean>>;
    publicUrl: string;
    translationKey: string;
}): React.ReactElement => {
    const { t } = useTranslation();

    const publicSharingURL = (
        <Collapse in={isPublic} timeout="auto" unmountOnExit>
            <List
                component="div"
                disablePadding
                sx={{ paddingLeft: '2.5rem', marginTop: '-1.25rem' }}
            >
                <ListItem>
                    <TextField
                        id="shareLink"
                        label={t('sharingModal.shareLink')}
                        value={publicUrl}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        helperText={t('sharingModal.shareLinkHelp')}
                        fullWidth
                        margin="normal"
                        InputProps={{
                            startAdornment: (
                                <CopyButtonAdornment inputId="shareLink" />
                            ),
                        }}
                    />
                </ListItem>
            </List>
        </Collapse>
    );

    return (
        <SharedItemUI
            title={t('sharingModal.publicSharing')}
            subtitle={
                <span>
                    {t(`sharingModal.${translationKey}.publicSharingSubtitle`)}
                </span>
            }
            isChecked={isPublic}
            onCheck={(_: SyntheticEvent<Element, Event>, checked: boolean) => {
                setIsPublic(checked);
            }}
            enabled
            icon={<LanguageIcon />}
        >
            {publicSharingURL}
        </SharedItemUI>
    );
};
